import { TreeLikeData } from "src/types/TreeLikeData";
import { ZEntityFilterStateConfig } from "./EntityFiltersStateStrategy";
import { EntityFilterTreeData } from "./AttsTree/types";

type FilterStateData = ZEntityFilterStateConfig["data"];
type FilterTreeNode = TreeLikeData<EntityFilterTreeData>;

const filterUniqueIds = (ids: string[], availableIds: Set<string>) => {
  const result = new Set(
    ids.filter((id) => availableIds.has(String(id))).map(String),
  );
  return Array.from(result);
};

export const reconcileEntityFilterState = (
  state: FilterStateData,
  availableIds: Set<string>,
): FilterStateData => {
  const treeKeys = new Set<string>();

  const reconcileTree = (nodes: FilterTreeNode[]): FilterTreeNode[] =>
    nodes
      .filter(({ attrId }) => availableIds.has(String(attrId)))
      .map((node) => {
        treeKeys.add(String(node.key));
        return {
          ...node,
          children: node.children
            ? reconcileTree(node.children)
            : node.children,
        };
      });

  const treeData = reconcileTree(state.treeSlected.treeData);

  return {
    ...state,
    attsOrder: filterUniqueIds(state.attsOrder, availableIds),
    attsSelected: filterUniqueIds(state.attsSelected, availableIds),
    treeSlected: {
      treeData,
      selected: state.treeSlected.selected.filter((key) =>
        treeKeys.has(String(key)),
      ),
      expanded: state.treeSlected.expanded.filter((key) =>
        treeKeys.has(String(key)),
      ),
    },
  };
};
